import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../services/app-settings.service';

@Injectable({
  providedIn: 'root',
})
export class CtGenLookupService {
  constructor(private httpClient: HttpClient) {}
  genLookup(
    lookupAd: string,
    anaKod?: number,
    donemKod?: number,
    page?: string,
    count?: string,
    filterKod?:string,
    anaKodStr?:string,
    date1?:string,
    aktifEh?:string,
  ): Observable<any> {
    const formData = new FormData();
    formData.append('lookupAd', lookupAd);
    if (anaKod) formData.append('anaKod', anaKod.toString());
    if (donemKod) formData.append('Donem', donemKod.toString());
    if (filterKod) formData.append('filterKod', filterKod.toString());
    if (page) formData.append('page', page);
    if (count) formData.append('count', count);
    if (anaKodStr) formData.append('anaKodStr', anaKodStr);
    if (date1) formData.append('Date1', date1);
    if (aktifEh) formData.append('aktifEh', aktifEh);
    return this.httpClient.post(
      `${environment.lookupService}api/GetLookup_Request?jsconfig=eccn%2Cedv`,
      formData
    );
  }

  getPersonWithRole<T, K>(key: string, kod: number, lookupType: string, formData: any, date1?:string): Observable<any> {
    return new Observable(observer => {
      this.genLookup(lookupType, kod, formData.Donem, null, null, null, null, date1).subscribe((res: any) => {
        if (res?.items.length > 0) {
          formData[key] = kod;
          observer.next({ personHasRole: true, roles:res.items });
        } else {
          formData[key] = kod;
          //formData[key + 'RolAd'] = null;
          observer.next({ personHasRole: false });
        }
      });
    });
  }




}
